<div class="files-filters-view" *ngIf="filterPanelOpen">
  <app-generic-filters-view (togglePanel)="toggleFilterPanel()"></app-generic-filters-view>
</div>
<div class="files-container" style="padding: 0">
  <div
    class="file-nav top-section d-flex align-items-center justify-content-between w-100"
    [class.file-nav--selected]="hasSelection"
  >
    <div class="d-flex justify-content-start align-items-center h-100">
      <button
        mat-icon-button
        *ngIf="!filterPanelOpen"
        class="pencil-filters-button pcl-files-tune-filter"
        (click)="filterPanelOpen = !filterPanelOpen"
      >
        <mat-icon> tune </mat-icon>
        <ng-container *ngIf="(filtersService.appliedFilters$ | async)?.length as filterCount">
          <span class="filters-badge">{{ filterCount }}</span>
        </ng-container>
      </button>
      <app-search-bar
        class="me-1 search-bar"
        [searchTitle]="'Search Files' | translate"
        (filter)="setSearchValue($event)"
        [editSearchValue]="filtersService.searchValue"
      >
      </app-search-bar>
      <mat-checkbox
        class="ms-1 selected-text"
        style="font-style: italic !important"
        *ngIf="hasSelection"
        [checked]="allSelected"
        [indeterminate]="hasSelection && !allSelected"
        (change)="toggleAll(false)"
        >{{ selectedFiles.length + selectedFolders.length }}
        {{
          selectedFiles.length + selectedFolders.length === 1
            ? ('item' | translate)
            : ('items' | translate)
        }}
        {{ 'selected' | translate }}</mat-checkbox
      >
      <span *ngIf="(filesLoading$ | async) === false && activeFolder" class="searchResult">
        {{ displayedResultsCount === 0 ? ('No' | translate) : displayedResultsCount }}
        {{ 'results found' | translate }}
      </span>
    </div>
    <div class="d-flex justify-content-end">
      <button
        mat-icon-button
        *ngIf="hasSelection"
        (click)="fileList?.deleteSelected()"
        [disabled]="!(user | has: Features.delete_resource)"
      >
        <i
          [ngbTooltip]="
            (user | has: Features.delete_resource)
              ? ('Delete Selection' | translate)
              : ('Your role does not allow this operation' | translate)
          "
          class="material-icons-outlined"
          >delete</i
        >
      </button>
      <button mat-icon-button (click)="switchView()" *ngIf="view === views.LIST">
        <i class="material-icons-outlined">grid_on</i>
      </button>
      <button
        mat-icon-button
        class="pcl-files-sort-filter"
        (click)="switchView()"
        *ngIf="view === views.GRID"
      >
        <i class="material-icons-outlined">sort</i>
      </button>
      <app-pencil-button
        *ngIf="hasSelection"
        class="pcl-files-selection-actions"
        theme="icon"
        icon="ellipsis"
        [iconConfig]="{ type: 'lucide-icon' }"
        [matMenuTriggerFor]="selectionActionsMenu"
        [attr.aria-label]="'More' | translate"
        data-name="files-selection-actions"
        buttonType="button"
      >
      </app-pencil-button>
      <mat-menu
        #selectionActionsMenu="matMenu"
        [hasBackdrop]="true"
        class="pencil-mat-menu light-scheme"
      >
        <div
          appTooltip="Your role does not allow this operation"
          [appTooltipDisabled]="user | has: Features.upload_resource"
        >
          <app-pencil-menu-item
            [label]="'Add to new folder' | translate"
            icon="folder_plus"
            [iconConfig]="{ type: 'lucide-icon' }"
            [disabled]="!(user | has: Features.upload_resource)"
            (clickEvent)="createFolderDialog()"
            data-name="files-create-folder-from-selection"
          >
          </app-pencil-menu-item>
        </div>
        <app-pencil-menu-item
          [label]="'Move to folder' | translate"
          icon="folder_input"
          [iconConfig]="{ type: 'lucide-icon' }"
          (clickEvent)="showMoveToFolderDialog()"
          data-name="files-move-selection-to-folder"
        >
        </app-pencil-menu-item>
      </mat-menu>
    </div>
  </div>
  <div *ngIf="breadcrumbParent as parent" class="folder-breadcrumb d-flex flex-row cmt-8 cmb-8">
    <div *ngIf="parent.name !== institutionId">
      <span class="material-icons"> more_horiz </span>
      <i class="material-icons">chevron_right</i>
    </div>
    <div class="folder" (click)="openBreadcrumbFolder(parent)">
      {{ parent.name === institutionId ? ('Files' | translate) : parent.name }}
    </div>
    <i class="material-icons">chevron_right</i>
    <div class="active">
      {{ activeFolder?.name === institutionId ? ('Files' | translate) : activeFolder?.name }}
    </div>
  </div>
  <!-- Applying Filters -->
  <app-applied-filter-pills
    *ngIf="(filtersService.appliedFilters$ | async)?.length"
    class="filter-border"
  ></app-applied-filter-pills>
  <div
    *ngIf="view === views.LIST && (currentFolders?.length || currentFiles?.length)"
    class="file-list-header"
  >
    <div class="d-flex flex-grow-1">
      <div class="flex-4">
        <div class="file-list-header__name">{{ 'Name' | translate }}</div>
      </div>
      <div class="flex-2">{{ 'Owner' | translate }}</div>
      <div class="flex-1">{{ 'Added' | translate }}</div>
    </div>
  </div>
  <div
    class="files-empty-content"
    *ngIf="!currentFolders?.length && !currentFiles?.length && (filesLoading$ | async) === false"
  >
    <div *ngIf="isFiltersApplied; else filesEmptyState" class="no-res-background">
      {{ 'No matching items found' | translate }}
    </div>
    <ng-template #filesEmptyState>
      <div
        class="files-empty-state"
        appDragAndDropFile
        (fileDropped)="handleFileDrop($event)"
        [class.files-empty-state--disabled]="!canUploadFiles"
        [attr.aria-disabled]="!canUploadFiles"
      >
        <div class="files-empty-state__content">
          <img
            class="files-empty-state__illustration"
            src="assets/imgs/files-empty-state.svg"
            width="167"
            height="100"
            alt=""
            aria-hidden="true"
          />
          <div class="files-empty-state__body">
            <h2 class="files-empty-state__title">
              {{ 'Drag and drop files here' | translate }}
            </h2>
            <p class="files-empty-state__formats">
              {{ 'Supported formats: images, documents, videos, and .space files' | translate }}
            </p>
            <div class="files-empty-state__separator" aria-hidden="true">
              <span class="files-empty-state__separator-line"></span>
              <span class="files-empty-state__separator-text">{{ 'or' | translate }}</span>
              <span class="files-empty-state__separator-line"></span>
            </div>
            <input
              #emptyStateFileInput
              class="files-empty-state__input"
              type="file"
              multiple
              [accept]="supportedUploadTypes"
              (change)="handleFileSelection($event)"
            />
            <app-pencil-button
              class="pencil-button primary medium files-empty-state__button pcl-files-file-upload"
              [label]="'Select file' | translate"
              [icon]="'attach_file'"
              [iconConfig]="{ type: IconTypes.materialIcon }"
              [disabled]="!canUploadFiles"
              (clickEvent)="emptyStateFileInput.click()"
            >
            </app-pencil-button>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
  <app-file-grid
    *ngIf="view === views.GRID"
    #filesList
    [activeFolder]="activeFolder"
    [draggingWithoutSelect]="true"
    [enforcingFilter]="enforcingFilter"
    [isCreatingFolder]="false"
    [canSelect]="true"
    [maxNameLength]="maxNameLength"
    [user]="user"
    [loading]="(filesLoading$ | async) && !scrolling"
    [hideFolders]="hideFoldersForCurrentView"
    (toggleSelectionEmitter)="handleToggleSelection()"
    (openFolder)="openFolder($event)"
    (scroll)="onScrollDown()"
    (snackbar)="showSnackbar($event)"
    (updateCache)="updateCacheFor($event.folderId, $event.resources, $event.folders)"
  >
  </app-file-grid>

  <app-file-list
    *ngIf="view === views.LIST"
    #filesList
    [activeFolder]="activeFolder"
    [draggingWithoutSelect]="true"
    [enforcingFilter]="enforcingFilter"
    [isCreatingFolder]="false"
    [canSelect]="true"
    [maxNameLength]="maxNameLength"
    [user]="user"
    [loading]="(filesLoading$ | async) && !scrolling"
    [hideFolders]="hideFoldersForCurrentView"
    (toggleSelectionEmitter)="handleToggleSelection()"
    (openFolder)="openFolder($event)"
    (scroll)="onScrollDown()"
    (snackbar)="showSnackbar($event)"
    (updateCache)="updateCacheFor($event.folderId, $event.resources, $event.folders)"
  >
  </app-file-list>

  <app-content-loader
    *ngIf="filesLoading$ | async"
    [blockCount]="25"
    [file]="view === views.GRID"
    [singleLineList]="view === views.LIST"
    [border]="false"
    [list]="view === views.LIST"
  >
  </app-content-loader>
</div>
<div class="file-upload-container" *ngIf="isUploading">
  <div class="file-upload-header">
    {{ 'Uploading' | translate }} {{ uploadFiles.length }} {{ 'files' | translate }}
  </div>
  <div class="file-upload-subheader">
    {{ actionText }}
    <button
      class="float-right mat-flat-button text-muted"
      (click)="onCancel()"
      [disabled]="finalizedFiles === uploadFiles.length"
    >
      {{ 'Cancel' | translate }}
    </button>
  </div>
  <div class="file-upload-tasks">
    <div class="w-100" *ngFor="let ufile of uploadFiles">
      <app-upload-task
        #uploadTask
        [file]="ufile"
        (uploadDone)="saveResource($event)"
      ></app-upload-task>
    </div>
  </div>
</div>
